var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailNew = function SvgMailNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#212fcc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-970.507 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(970.507 16)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(978.908 25.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.486,10.026a1.456,1.456,0,0,1-.887.253,1.456,1.456,0,0,1-.887-.253L0,6.416v6.4a1.9,1.9,0,0,0,1.9,1.9H13.3a1.9,1.9,0,0,0,1.9-1.9v-6.4Z",
    transform: "translate(0 -2.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.3.666H1.9A1.9,1.9,0,0,0,0,2.566V3.2a.665.665,0,0,0,.317.57l6.966,3.8a.57.57,0,0,0,.317.063.57.57,0,0,0,.317-.063l6.966-3.8A.665.665,0,0,0,15.2,3.2V2.566a1.9,1.9,0,0,0-1.9-1.9Z",
    transform: "translate(0 -0.666)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MailNew.590a6d91.svg";
export { ForwardRef as ReactComponent };